import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
import compose from 'lodash/fp/compose';

import ActionButton from 'jbc-front/components/ActionButton';
import { Task, MinusCircle } from 'jbc-front/components/icons';

import { FormErrors } from 'src/components';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';
import { EditActionBtn, SaveActionBtn } from 'src/buttons';
import { REPORT_LABOR_INSURANCE_SUMMARY_FORM } from 'src/constants/FormNames';
import { REPORT_LABOR_INSURANCE_SUMMARIES_PDF } from 'src/constants/EndpointUrls';
import { getList, getExtras } from 'src/reducers/common/listReducer';
import {
  REDUCER_NAME,
  editMonthlySummary,
  setSummaryTableShowMode,
  transformMonthlySummariesToFormValues,
  recalculateReportLaborInsuranceSummaryList,
  clearMonthlySummaryErrors
} from 'src/reducers/reports/reportLaborInsurances';
import MonthlySummaryAccidentInsurance from './MonthlySummaryAccidentInsurance';
import MonthlySummaryEmploymentInsurance from './MonthlySummaryEmploymentInsurance';
import YearlySummaryAccidentInsurance from './YearlySummaryAccidentInsurance';
import YearlySummaryEmploymentInsurance from './YearlySummaryEmploymentInsurance';
import ConfirmRecalcurateSummaryListModal from './ConfirmRecalcurateSummaryListModal';
import styles from './SummaryList.scss';

class SummaryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPdfPreview: false,
      monthlySummaries: this.props.monthlySummaries,
      isRecalcurateSummaryListModalOpen: false
    };
    this.child = {};

    this.openRecalcurateSummaryListModal = this.openRecalcurateSummaryListModal.bind(this);
    this.closeRecalcurateSummaryListModal = this.closeRecalcurateSummaryListModal.bind(this);
  }

  showPreview = () => {
    this.setState({ ...this.state, isPdfPreview: true });
  };
  hidePreview = () => {
    this.setState({ ...this.state, isPdfPreview: false });
  };

  calcYearlySummary = params => {
    let newMonthlySummaries = this.state.monthlySummaries;
    if (!newMonthlySummaries) newMonthlySummaries = this.props.monthlySummaries;

    newMonthlySummaries = _.map(newMonthlySummaries, o => {
      if (params && o.id === params.id) return params;
      return o;
    });

    this.setState({
      ...this.state,
      monthlySummaries: newMonthlySummaries
    });
    this.child1.calculation(newMonthlySummaries);
    this.child2.calculation(newMonthlySummaries);
  };

  rollbackMonthlySummaries() {
    this.props.monthlySummaries.map(monthlySummary => this.child[monthlySummary.id].calculation(monthlySummary));
    this.child1.calculation(this.props.monthlySummaries);
    this.setState({
      ...this.state,
      monthlySummaries: this.props.monthlySummaries
    });
  }

  openRecalcurateSummaryListModal() {
    if (this.state.isRecalcurateSummaryListModalOpen) return;
    this.setState({ ...this.state, isRecalcurateSummaryListModalOpen: true });
  }

  closeRecalcurateSummaryListModal() {
    if (!this.state.isRecalcurateSummaryListModalOpen) return;
    this.setState({ ...this.state, isRecalcurateSummaryListModalOpen: false });
  }

  pdfUrl = laborInsuranceYear =>
    `${REPORT_LABOR_INSURANCE_SUMMARIES_PDF}?&pdf[labor_insurance_year]=${laborInsuranceYear}`;

  pdfDownloadUrl = laborInsuranceYear =>
    `${REPORT_LABOR_INSURANCE_SUMMARIES_PDF}?pdf[type]=zip&pdf[labor_insurance_year]=${laborInsuranceYear}`;

  render() {
    const {
      pristine,
      submitting,
      actionMode,
      laborInsuranceYear,
      monthlySummaries,
      yearlySummary,
      reset,
      save,
      changeToEditMode,
      changeToViewMode,
      clearErrorMessages,
      errors
    } = this.props;
    return (
      <div className="u-mt20">
        {!laborInsuranceYear && (
          <div className={styles.empty_messages}>
            <div>登録済みの給与・賞与データがありません。</div>
          </div>
        )}
        {laborInsuranceYear &&
          (!monthlySummaries || monthlySummaries.length === 0) && (
            <div className={styles.empty_messages}>
              <div>{laborInsuranceYear}年度に登録済みの給与・賞与データがありません。</div>
              <div>{laborInsuranceYear + 1}年3月締めの給与を確定させると表示されます。</div>
            </div>
          )}
        {monthlySummaries &&
          monthlySummaries.length > 0 && (
            <div>
              <FormErrors errors={errors} />
              <div className={styles.action}>
                <div>
                  {actionMode === 'SHOW' ? (
                    <React.Fragment>
                      <EditActionBtn
                        onClick={() => {
                          changeToEditMode();
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <SaveActionBtn as="div" onClick={save} disabled={pristine || submitting} className="u-mr10" />
                      <ActionButton
                        onClick={() => {
                          reset();
                          this.rollbackMonthlySummaries();
                          clearErrorMessages();
                          changeToViewMode();
                        }}
                        className="u-mr10"
                        icon={<MinusCircle size={15} />}
                      >
                        キャンセル
                      </ActionButton>
                      <ActionButton onClick={this.openRecalcurateSummaryListModal} className="u-mr10">
                        再計算
                      </ActionButton>
                    </React.Fragment>
                  )}
                </div>
                <ActionButton
                  primary
                  icon={<Task size={16} />}
                  disabled={actionMode !== 'SHOW'}
                  onClick={this.showPreview}
                >
                  PDF出力
                </ActionButton>
              </div>
              <div className="l-overflow-scroll">
                <table className={styles.table}>
                  <colgroup>
                    <col width={138} />
                    <col width={85} />
                    <col width={120} />
                    <col width={85} />
                    <col width={120} />
                    <col width={85} />
                    <col width={120} />
                    <col width={85} />
                    <col width={120} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th />
                      <th colSpan="8">労災保険および一般拠出金（対象者数及び賃金）</th>
                    </tr>
                    <tr>
                      <td rowSpan="2" />
                      <td colSpan="2">常用労働者</td>
                      <td colSpan="2">役員で従業員扱いの人</td>
                      <td colSpan="2">臨時労働者</td>
                      <td colSpan="2">合計</td>
                    </tr>
                    <tr>
                      <td>人数</td>
                      <td>賃金</td>
                      <td>人数</td>
                      <td>賃金</td>
                      <td>人数</td>
                      <td>賃金</td>
                      <td>人数</td>
                      <td>賃金</td>
                    </tr>
                  </thead>
                  <tbody>
                    {(!monthlySummaries || monthlySummaries.length === 0) && (
                      <tr>
                        <td colSpan={9}>データがありません。</td>
                      </tr>
                    )}
                    {monthlySummaries &&
                      monthlySummaries.length > 0 &&
                      monthlySummaries.map(monthlySummary => (
                        <MonthlySummaryAccidentInsurance
                          key={`${monthlySummary.id}`}
                          actionMode={actionMode}
                          monthlySummary={monthlySummary}
                          monthlySummaries={monthlySummaries}
                          calcYearlySummary={this.calcYearlySummary}
                          onRef={ref => {
                            this.child[monthlySummary.id] = ref;
                          }}
                        />
                      ))}
                    {monthlySummaries &&
                      monthlySummaries.length > 0 && (
                        <YearlySummaryAccidentInsurance
                          monthlySummaries={monthlySummaries}
                          yearlySummary={yearlySummary}
                          onRef={ref => {
                            this.child1 = ref;
                          }}
                        />
                      )}
                  </tbody>
                </table>
                <table className={`${styles.table} u-mt30`}>
                  <colgroup>
                    <col width={138} />
                    <col width={85} />
                    <col width={120} />
                    <col width={85} />
                    <col width={120} />
                    <col width={85} />
                    <col width={120} />
                    <col width={85} />
                    <col width={120} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th />
                      <th colSpan="8">雇用保険（対象者及び賃金）</th>
                    </tr>
                    <tr>
                      <td rowSpan="2" />
                      <td colSpan="2">雇用保険資格のある従業員</td>
                      <td colSpan="2">雇用保険資格のある役員</td>
                      <td colSpan="2">合計</td>
                      <td colSpan="2">免除対象高年齢労働者分</td>
                    </tr>
                    <tr>
                      <td>人数</td>
                      <td>賃金</td>
                      <td>人数</td>
                      <td>賃金</td>
                      <td>人数</td>
                      <td>賃金</td>
                      <td>人数</td>
                      <td>賃金</td>
                    </tr>
                  </thead>
                  <tbody>
                    {(!monthlySummaries || monthlySummaries.length === 0) && (
                      <tr>
                        <td colSpan={9}>データがありません。</td>
                      </tr>
                    )}
                    {monthlySummaries &&
                      monthlySummaries.length > 0 &&
                      monthlySummaries.map(monthlySummary => (
                        <MonthlySummaryEmploymentInsurance
                          key={`${monthlySummary.id}`}
                          actionMode={actionMode}
                          monthlySummary={monthlySummary}
                          monthlySummaries={monthlySummaries}
                          calcYearlySummary={this.calcYearlySummary}
                          onRef={ref => {
                            this.child[monthlySummary.id] = ref;
                          }}
                        />
                      ))}
                    {monthlySummaries &&
                      monthlySummaries.length > 0 && (
                        <YearlySummaryEmploymentInsurance
                          monthlySummaries={monthlySummaries}
                          yearlySummary={yearlySummary}
                          onRef={ref => {
                            this.child2 = ref;
                          }}
                        />
                      )}
                  </tbody>
                </table>
              </div>
              <PreviewPdfModalContainer
                header="算定基礎賃金集計表"
                isOpen={this.state.isPdfPreview}
                hideModal={this.hidePreview}
                url={this.pdfUrl(laborInsuranceYear)}
                downloadUrl={this.pdfDownloadUrl(laborInsuranceYear)}
              />
              {this.state.isRecalcurateSummaryListModalOpen && (
                <ConfirmRecalcurateSummaryListModal
                  isOpen={this.state.isRecalcurateSummaryListModalOpen}
                  hideModal={this.closeRecalcurateSummaryListModal}
                  laborInsuranceYear={laborInsuranceYear}
                />
              )}
            </div>
          )}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  actionMode: getExtras(REDUCER_NAME, state).summaryTableShowMode || 'SHOW',
  monthlySummaries: getList(REDUCER_NAME, state).monthlySummaries,
  yearlySummary: getList(REDUCER_NAME, state).yearlySummary,
  initialValues: transformMonthlySummariesToFormValues(state),
  errors: getExtras(REDUCER_NAME, state).editMonthlySummaryErrors || []
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  save: () => {
    dispatch(editMonthlySummary(ownProps.laborInsuranceYear));
  },
  changeToEditMode: () => {
    dispatch(setSummaryTableShowMode('EDIT'));
  },
  changeToViewMode: () => {
    dispatch(setSummaryTableShowMode('SHOW'));
  },
  recalculate: () => {
    dispatch(recalculateReportLaborInsuranceSummaryList(ownProps.laborInsuranceYear));
  },
  clearErrorMessages: () => {
    dispatch(clearMonthlySummaryErrors());
  }
});
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: REPORT_LABOR_INSURANCE_SUMMARY_FORM,
    enableReinitialize: true
  })
)(SummaryList);
